import PropTypes from "prop-types";
import ParticleTwo from "../../particles/ParticleTwo";
import { Link } from "react-router-dom";
const BreadcrumbStandardAccounts = () => {
  return (
    <div
      className="ht__bradcaump__area_market"
      style={{
        background: `rgba(0, 0, 0, 0) url(${
          process.env.PUBLIC_URL + "/images/about/bull_right_side.jpg"
        }) repeat scroll center center/105% 100%`,
      }}
    >
      <div className="ht__bradcaump__container_market">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <h1>Partner With The Pips</h1>
              <p>
                Grow your business with a trading ecosystem built on trust,
                technology, and transparent rewards.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Start Now
              </Link>
            </div>
          </div>  
        </div>
      </div>
      {/* <ParticleTwo /> */}
    </div>
  );
};

BreadcrumbStandardAccounts.propTypes = {
  title: PropTypes.string,
};

export default BreadcrumbStandardAccounts;
